import React, { useState } from "react";
import { Link } from "react-router-dom";
import useAxios from "../../utility/axios-token-manager/init";
import Flash from "../../utility/Flash";
import logo from "../asset/img/Excite WLL.png";

const PRIMARY = "#a7cc48";
const DARK = "#2c2d3f";
const DARK2 = "#1e1f2e";

const QUICK_LINKS = [
  { label: "Home", href: "https://exciteenterprise.com/#home" },
  { label: "Services", href: "https://exciteenterprise.com/#home" },
  { label: "Privacy Policy", href: "https://exciteenterprise.com/privacy" },
  {
    label: "Terms & Conditions",
    href: "https://exciteenterprise.com/terms_conditions",
  },
  { label: "Funding Services", href: "https://exciteenterprise.com" },
  { label: "Business Promotions", href: "https://exciteenterprise.com" },
];

const SOCIAL = [
  {
    icon: "bi bi-facebook",
    href: "https://www.facebook.com/Excite-Enterprise-109200980956538",
  },
  { icon: "bi bi-twitter", href: "https://www.twitter.com/excitebusiness" },
  {
    icon: "bi bi-instagram",
    href: "https://www.instagram.com/exciteenterprise",
  },
  {
    icon: "bi bi-linkedin",
    href: "https://www.linkedin.com/in/excite-africa-4632a71b9/",
  },
  { icon: "bi bi-whatsapp", href: "https://wa.me/2349138650923" },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async () => {
    if (!email.trim()) return;
    setBusy(true);
    try {
      await useAxios.post("/support/newsletter", { email });
      Flash("success", "You're subscribed!", "", 3000);
      setEmail("");
    } catch {
      Flash("error", "Subscription failed, try again", "", 3000);
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer>
      <style>{`
        .ft-social:hover { background: rgba(167,204,72,0.25) !important; transform: scale(1.08); }
        .ft-link:hover { color: ${PRIMARY} !important; }
        .ft-news-btn:hover:not(:disabled) { filter: brightness(1.1); }
        .ft-bottom-link:hover { color: rgba(255,255,255,0.65) !important; }
      `}</style>

      <div style={s.root}>
        <div style={s.inner}>
          <div style={s.grid}>
            {/* About */}
            <div>
              <img src={logo} alt='Excite Enterprise' style={s.logo} />
              <p style={s.about}>
                Excite Enterprise provides tools for micro, small and medium
                businesses to reach consumers, boost brand names and grow sales
                across Africa.
              </p>
              <div style={s.socials}>
                {SOCIAL.map(({ icon, href }) => (
                  <a
                    key={href}
                    href={href}
                    target='_blank'
                    rel='noreferrer'
                    className='ft-social'
                    style={s.socialBtn}
                  >
                    <i className={icon} />
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 style={s.colHead}>Quick Links</h4>
              <ul style={s.list}>
                {QUICK_LINKS.map(({ label, href }) => (
                  <li key={label}>
                    <a
                      href={href}
                      target='_blank'
                      rel='noreferrer'
                      className='ft-link'
                      style={s.ftLink}
                    >
                      <i className='bi bi-chevron-right' style={s.chevron} />
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Newsletter */}
            <div>
              <h4 style={s.colHead}>Newsletter</h4>
              <p style={s.colText}>
                Get updates and news from Excite Enterprise.
              </p>
              <div style={s.newsWrap}>
                <input
                  type='email'
                  placeholder='Your email address'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && subscribe()}
                  style={s.newsInput}
                />
                <button
                  onClick={subscribe}
                  disabled={busy}
                  className='ft-news-btn'
                  style={s.newsBtn}
                >
                  {busy ? "..." : "Subscribe"}
                </button>
              </div>
            </div>

            {/* Contact */}
            <div>
              <h4 style={s.colHead}>Contact Us</h4>
              <ul style={{ ...s.list, gap: 16 }}>
                <li style={s.contactRow}>
                  <i className='bi bi-geo-alt-fill' style={s.contactIcon} />
                  <span style={s.colText}>
                    3, Dapo Bode Thomas Street, Off Thurborn Avenue, Yaba,
                    Lagos.
                  </span>
                </li>
                <li style={s.contactRow}>
                  <i className='bi bi-telephone-fill' style={s.contactIcon} />
                  <a
                    href='tel:+2349138650923'
                    className='ft-link'
                    style={s.ftLink}
                  >
                    +2349138650923
                  </a>
                </li>
                <li style={s.contactRow}>
                  <i className='bi bi-envelope-fill' style={s.contactIcon} />
                  <a
                    href='mailto:info@exciteafrica.com'
                    className='ft-link'
                    style={s.ftLink}
                  >
                    info@exciteafrica.com
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom strip */}
          <div style={s.strip}>
            <p style={s.copyright}>
              © {new Date().getFullYear()} Excite Enterprise · All rights
              reserved
            </p>
            <div style={s.bottomLinks}>
              <Link
                to='/accounts?q=login'
                className='ft-bottom-link'
                style={s.bottomLink}
              >
                Agent Login
              </Link>
              <span style={s.dot}>·</span>
              <Link
                to='/accounts?q=sign-up'
                className='ft-bottom-link'
                style={s.bottomLink}
              >
                Register as Agent
              </Link>
              <span style={s.dot}>·</span>
              <Link
                to='/sales-admin/accounts?q=login'
                className='ft-bottom-link'
                style={s.bottomLink}
              >
                Sales Admin
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

const s = {
  root: {
    background: DARK2,
    borderTop: `3px solid ${PRIMARY}`,
  },
  inner: {
    padding: "60px 6vw 0",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(210px, 1fr))",
    gap: "40px 32px",
    paddingBottom: 48,
  },
  logo: { height: 34, marginBottom: 16, display: "block" },
  about: {
    fontSize: 13,
    color: "rgba(255,255,255,0.42)",
    lineHeight: 1.75,
    marginBottom: 20,
    maxWidth: 260,
  },
  socials: { display: "flex", gap: 8, flexWrap: "wrap" },
  socialBtn: {
    width: 36,
    height: 36,
    borderRadius: "50%",
    background: "rgba(167,204,72,0.1)",
    border: "1px solid rgba(167,204,72,0.2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: PRIMARY,
    textDecoration: "none",
    fontSize: 14,
    transition: "background 0.2s, transform 0.2s",
  },
  colHead: {
    fontSize: 11,
    fontWeight: 700,
    color: "#fff",
    textTransform: "uppercase",
    letterSpacing: 1.4,
    marginBottom: 18,
    paddingBottom: 10,
    borderBottom: `2px solid ${PRIMARY}`,
    display: "inline-block",
  },
  list: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  ftLink: {
    fontSize: 13,
    color: "rgba(255,255,255,0.48)",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    transition: "color 0.2s",
  },
  chevron: { fontSize: 10, color: PRIMARY },
  colText: {
    fontSize: 13,
    color: "rgba(255,255,255,0.42)",
    lineHeight: 1.65,
    margin: 0,
  },
  newsWrap: {
    display: "flex",
    marginTop: 12,
    border: "1.5px solid rgba(255,255,255,0.1)",
    borderRadius: 8,
    overflow: "hidden",
  },
  newsInput: {
    flex: 1,
    background: "transparent",
    border: "none",
    outline: "none",
    padding: "10px 14px",
    color: "#fff",
    fontSize: 13,
  },
  newsBtn: {
    background: PRIMARY,
    border: "none",
    padding: "10px 16px",
    color: DARK,
    fontWeight: 700,
    fontSize: 13,
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "filter 0.2s",
  },
  contactRow: { display: "flex", gap: 10, alignItems: "flex-start" },
  contactIcon: { color: PRIMARY, fontSize: 14, marginTop: 2, flexShrink: 0 },
  strip: {
    borderTop: "1px solid rgba(255,255,255,0.07)",
    padding: "20px 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 10,
  },
  copyright: { fontSize: 12, color: "rgba(255,255,255,0.22)", margin: 0 },
  bottomLinks: { display: "flex", alignItems: "center", gap: 8 },
  bottomLink: {
    fontSize: 12,
    color: "rgba(255,255,255,0.28)",
    textDecoration: "none",
    transition: "color 0.2s",
  },
  dot: { fontSize: 12, color: "rgba(255,255,255,0.12)" },
};
